<div class="grid-cols" [formGroup]="formGroup">
  <mat-form-field>
    <mat-label>Dato</mat-label>
    <input
      matInput
      [matDatepicker]="datepicker"
      formControlName="whenToSendInviteDate"
      placeholder="Start dato"
      [matDatepickerFilter]="dateFilter" />
    <mat-datepicker-toggle matPrefix [for]="datepicker">
      <svg matDatepickerToggleIcon class="icon-24">
        <use href="/assets/images/ok-icons-sprite.svg#calendar-s"></use>
      </svg>
    </mat-datepicker-toggle>
    <mat-datepicker #datepicker></mat-datepicker>
    @if (formGroup.controls['whenToSendInviteDate'].invalid) {
      <mat-error>Vælg en dato.</mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <mat-label>Tidspunkt</mat-label>
    <input
      matInput
      [matTimepicker]="timepicker"
      [matTimepickerMin]="minTime()"
      formControlName="whenToSendInviteTime"
      placeholder="Vælg tidspunkt"
      autocomplete="false" />
    <mat-timepicker #timepicker [interval]="'5m'" />
    <mat-timepicker-toggle [for]="timepicker" matSuffix />

    @if (formGroup.controls['whenToSendInviteTime'].invalid) {
      <mat-error>{{ getTimeErrorMessage() }}</mat-error>
    }
  </mat-form-field>
</div>
